class ScrollToDirective {
    constructor($window, $timeout) {
        this.restrict = 'A';
        this.$window = $window;
        this.$timeout = $timeout;
        this.scope = {};
        this.element = null;
    }

    link(scope, element, attrs) {

        scope.element = element;
        const scrollDelay = attrs.scrollDelay ? attrs.scrollDelay : 0;
        const scrollMaxWidth = attrs.scrollMaxWidth ? attrs.scrollMaxWidth : null;
        const scrollToId = attrs.scrollToId ? attrs.scrollToId : null;

        element.on('click', () => {
            if (scrollDelay) {
                this.$timeout(() => {
                    scope.scrollTo();
                }, scrollDelay);

                return;
            }
            scope.scrollTo();
        });

        scope.scrollTo = () => {
            if (scrollMaxWidth && !this.$window.matchMedia(`(max-width: ${scrollMaxWidth}px)`).matches) {
                return;
            }
            let targetX = 0;
            let targetY = 0;
            if (scrollToId) {
                const targetElement = document.getElementById(scrollToId);
                targetY = targetElement ? targetElement.getBoundingClientRect().top - 15 + this.$window.scrollY : 0;
            }
            this.$window.scrollTo(targetX, targetY);
            const header = document.getElementsByTagName('header')[0];
            header.scrollTo(0, scope.element[0].getBoundingClientRect().top + header.scrollTop);
        }
    }

    static directiveFactory($window, $timeout) {
        'ngInject';
        return new ScrollToDirective($window, $timeout);
    }
}

export default ScrollToDirective;
